(() => {
  const menuButton = document.querySelector('.menu-toggle');
  const siteNav = document.querySelector('#SiteNav');

  if (menuButton && siteNav) {
    menuButton.addEventListener('click', () => {
      const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!isOpen));
      siteNav.classList.toggle('is-open', !isOpen);
    });
    siteNav.addEventListener('click', (event) => {
      if (!event.target.closest('a, [data-enquiry-open]')) return;
      menuButton.setAttribute('aria-expanded', 'false');
      siteNav.classList.remove('is-open');
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        menuButton.setAttribute('aria-expanded', 'false');
        siteNav.classList.remove('is-open');
      }
    });
  }

  const enquiryDialog = document.querySelector('#GiftoraEnquiryDialog');
  if (enquiryDialog) {
    const enquirySummary = enquiryDialog.querySelector('[data-enquiry-summary]');
    const giftMessage = enquiryDialog.querySelector('[name="contact[Gift message]"]');
    let previousFocus;
    const openEnquiry = (trigger) => {
      previousFocus = trigger;
      const details = [];
      const productSection = trigger.closest('[data-product-section]');
      if (productSection) {
        const title = productSection.querySelector('h1')?.textContent.trim();
        const variant = productSection.querySelector('[data-variant-select] option:checked')?.textContent.trim() || 'Default option';
        const quantity = productSection.querySelector('[name="quantity"]')?.value || '1';
        const price = productSection.querySelector('[data-current-price]')?.textContent.trim();
        if (title) details.push(`Product: ${title}`, `Option: ${variant}`, `Quantity: ${quantity}`);
        if (price) details.push(`Displayed price: ${price}`);
        const productGiftMessage = productSection.querySelector('#GiftNote')?.value.trim();
        if (giftMessage && productGiftMessage) giftMessage.value = productGiftMessage;
      } else if (trigger.dataset.enquiryContext === 'cart') {
        document.querySelectorAll('.cart-item').forEach((item) => {
          const title = item.querySelector('.cart-item-info strong')?.textContent.trim();
          const quantity = item.querySelector('.cart-quantity input')?.value || '1';
          if (title) details.push(`${title} × ${quantity}`);
        });
        const total = document.querySelector('.cart-total strong')?.textContent.trim();
        if (total) details.push(`Cart total: ${total}`);
        const note = document.querySelector('#CartNote')?.value.trim();
        if (note) details.push(`Delivery or gifting notes: ${note}`);
      }
      if (enquirySummary) enquirySummary.value = details.join('\n') || 'General gifting enquiry';
      if (!enquiryDialog.open) enquiryDialog.showModal();
      enquiryDialog.querySelector('input[name="contact[name]"]')?.focus();
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-enquiry-open]');
      if (!trigger) return;
      event.preventDefault();
      openEnquiry(trigger);
    });
    enquiryDialog.querySelector('[data-enquiry-close]')?.addEventListener('click', () => enquiryDialog.close());
    enquiryDialog.addEventListener('click', (event) => {
      if (event.target === enquiryDialog) enquiryDialog.close();
    });
    enquiryDialog.addEventListener('close', () => previousFocus?.focus());
    if (enquiryDialog.querySelector('.form-success, .form-errors, .errors, .enquiry-success')) enquiryDialog.showModal();
  }

  document.querySelectorAll('[data-hero-track]').forEach((track) => {
    const slides = [...track.querySelectorAll('[data-hero-slide]')];
    const dots = [...track.parentElement.querySelectorAll('[data-hero-dot]')];
    if (slides.length < 2) return;

    const setActive = (index) => {
      dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === index)));
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.heroDot);
        slides[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const index = slides.indexOf(entry.target);
        if (index >= 0) setActive(index);
      });
    }, { root: track, threshold: 0.6 });
    slides.forEach((slide) => observer.observe(slide));
  });

  document.querySelectorAll('[data-product-gallery-card]').forEach((gallery) => {
    const images = [...gallery.querySelectorAll('[data-card-image]')];
    const dots = [...gallery.querySelectorAll('[data-card-dot]')];
    dots.forEach((dot) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const index = Number(dot.dataset.cardDot);
        images.forEach((image, imageIndex) => {
          const active = imageIndex === index;
          image.classList.toggle('is-active', active);
          image.setAttribute('aria-hidden', String(!active));
          image.tabIndex = active ? 0 : -1;
        });
        dots.forEach((item, dotIndex) => item.setAttribute('aria-pressed', String(dotIndex === index)));
      });
    });
  });

  document.querySelectorAll('[data-product-section]').forEach((productSection) => {
    const frames = [...productSection.querySelectorAll('[data-product-frame]')];
    const thumbs = [...productSection.querySelectorAll('[data-product-thumb]')];
    const galleryMain = productSection.querySelector('[data-product-gallery-main]');
    const mobileGallery = window.matchMedia('(max-width: 749px)');
    const setActiveFrame = (index) => {
      frames.forEach((frame, frameIndex) => {
        const active = frameIndex === index;
        frame.classList.toggle('is-active', active);
        frame.setAttribute('aria-hidden', String(!active));
      });
      thumbs.forEach((button, buttonIndex) => button.setAttribute('aria-pressed', String(Number(button.dataset.productThumb) === index)));
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = Number(thumb.dataset.productThumb);
        setActiveFrame(index);
      });
    });

    if (galleryMain && frames.length > 1) {
      let touchStartX = null;
      galleryMain.addEventListener('touchstart', (event) => {
        touchStartX = mobileGallery.matches && event.touches.length === 1
          ? event.touches[0].clientX
          : null;
      }, { passive: true });
      galleryMain.addEventListener('touchend', (event) => {
        if (touchStartX === null || !mobileGallery.matches) return;
        const distance = touchStartX - event.changedTouches[0].clientX;
        touchStartX = null;
        if (Math.abs(distance) < 45) return;
        const currentIndex = frames.findIndex((frame) => frame.classList.contains('is-active'));
        const nextIndex = Math.max(0, Math.min(frames.length - 1, currentIndex + (distance > 0 ? 1 : -1)));
        if (nextIndex !== currentIndex) setActiveFrame(nextIndex);
      }, { passive: true });
    }

    productSection.querySelectorAll('[data-quantity-step]').forEach((button) => {
      button.addEventListener('click', () => {
        const input = button.parentElement.querySelector('input');
        const current = Number(input.value) || 1;
        const minimum = Number(input.min) || 1;
        const maximum = Number(input.max) || 99;
        input.value = String(Math.min(maximum, Math.max(minimum, current + Number(button.dataset.quantityStep))));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    const productForm = productSection.querySelector('[data-product-form]');
    const feedback = productSection.querySelector('[data-cart-add-feedback]');
    const feedbackMessage = feedback?.querySelector('[data-cart-add-message]');
    const cartLink = feedback?.querySelector('[data-cart-add-link]');
    const addButton = productForm?.querySelector('[name="add"]');
    const addLabel = addButton?.querySelector('[data-add-label]');
    if (productForm && addButton && feedback && feedbackMessage) {
      productForm.addEventListener('submit', async (event) => {
        if (event.submitter?.name === 'checkout' || event.submitter?.closest('.shopify-payment-button')) return;
        event.preventDefault();
        if (addButton.disabled) return;

        const quantityInput = productForm.querySelector('[name="quantity"]');
        const quantity = Math.max(1, Math.min(99, Number(quantityInput?.value) || 1));
        if (quantityInput) quantityInput.value = String(quantity);
        const originalLabel = addLabel?.textContent || 'Add to gift bag';
        addButton.disabled = true;
        if (addLabel) addLabel.textContent = 'Adding...';
        feedback.hidden = false;
        feedback.dataset.state = 'loading';
        feedbackMessage.textContent = 'Adding this gift to your bag...';
        if (cartLink) cartLink.hidden = true;

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(productForm)
          });
          let result;
          try { result = await response.json(); } catch { result = {}; }
          if (!response.ok) throw new Error(result.description || result.message || 'This gift could not be added. Please check the selected option and try again.');

          feedback.dataset.state = 'success';
          feedbackMessage.textContent = `${result.product_title || productSection.querySelector('h1')?.textContent.trim() || 'Gift'} added to your bag.`;
          if (cartLink) cartLink.hidden = false;
          try {
            const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              document.querySelectorAll('.cart-count').forEach((count) => { count.textContent = String(cart.item_count); });
              document.querySelectorAll('.cart-link').forEach((link) => { link.setAttribute('aria-label', `Cart, ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`); });
            }
          } catch { /* The add succeeded; the next page load will refresh the cart count. */ }
        } catch (error) {
          feedback.dataset.state = 'error';
          feedbackMessage.textContent = error instanceof Error ? error.message : 'This gift could not be added. Please try again.';
        } finally {
          addButton.disabled = false;
          if (addLabel) addLabel.textContent = originalLabel;
        }
      });
    }

    const imageDialog = productSection.querySelector('[data-product-image-dialog]');
    const zoomButton = productSection.querySelector('[data-product-zoom]');
    const largeImage = imageDialog?.querySelector('[data-product-image-large]');
    zoomButton?.addEventListener('click', () => {
      const activeImage = productSection.querySelector('[data-product-frame].is-active img');
      if (!imageDialog || !largeImage || !activeImage) return;
      largeImage.src = activeImage.currentSrc || activeImage.src;
      largeImage.alt = activeImage.alt || productSection.querySelector('h1')?.textContent.trim() || 'Product image';
      imageDialog.showModal();
    });
    imageDialog?.querySelector('[data-product-image-close]')?.addEventListener('click', () => imageDialog.close());
    imageDialog?.addEventListener('click', (event) => {
      if (event.target === imageDialog) imageDialog.close();
    });

    const variantSelect = productSection.querySelector('[data-variant-select]');
    const jsonElement = productSection.querySelector('[data-product-json]');
    if (variantSelect && jsonElement) {
      try {
        const product = JSON.parse(jsonElement.textContent);
        variantSelect.addEventListener('change', () => {
          const variant = product.variants.find((item) => String(item.id) === variantSelect.value);
          if (!variant) return;
          const price = productSection.querySelector('[data-current-price]');
          const comparePrice = productSection.querySelector('[data-compare-price]');
          const compareWrap = productSection.querySelector('[data-compare-wrap]');
          const savings = productSection.querySelector('[data-savings]');
          const savingsAmount = productSection.querySelector('[data-savings-amount]');
          const submit = productSection.querySelector('[name="add"]');
          if (price) price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: product.currency || 'INR' }).format(variant.price / 100);
          if (comparePrice) {
            const discounted = Boolean(variant.compare_at_price && variant.compare_at_price > variant.price);
            comparePrice.hidden = !discounted;
            if (compareWrap) compareWrap.hidden = !discounted;
            if (savings) savings.hidden = !discounted;
            if (discounted) {
              const formatPrice = (amount) => new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: product.currency || 'INR' }).format(amount / 100);
              comparePrice.textContent = formatPrice(variant.compare_at_price);
              if (savingsAmount) savingsAmount.textContent = formatPrice(variant.compare_at_price - variant.price);
            }
          }
          const available = variant.available || variant.inventory_policy === 'continue';
          const availability = productSection.querySelector('[data-product-availability]');
          if (submit) {
            submit.disabled = !available;
            const label = submit.querySelector('[data-add-label]');
            if (label) label.textContent = available ? 'Add to gift bag' : 'Sold out';
          }
          if (availability) {
            availability.classList.toggle('is-unavailable', !available);
            availability.innerHTML = available ? '<span aria-hidden="true">✓</span> Available to order' : '<span aria-hidden="true">•</span> Currently unavailable';
          }
        });
      } catch {
        variantSelect.addEventListener('change', () => {});
      }
    }
  });

  document.querySelectorAll('[data-cart-page]').forEach((cartPage) => {
    cartPage.querySelectorAll('[data-cart-quantity-step]').forEach((button) => {
      button.addEventListener('click', () => {
        const input = button.parentElement.querySelector('input[name="updates[]"]');
        if (!input) return;
        const minimum = Number(input.min) || 0;
        const maximum = Number(input.max) || 99;
        const current = Number(input.value) || 0;
        input.value = String(Math.min(maximum, Math.max(minimum, current + Number(button.dataset.cartQuantityStep))));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => select.form.submit());
  });
})();
